<script lang="ts">
  import { onMount, type Snippet } from 'svelte'
  import { getCsrfToken, getInertiaCsrfToken } from 'shared/javascripts/util/csrf'

  let { action, children }: { action: string; children: Snippet } = $props()

  // Read from the cookie, which the server render doesn't have.
  let token = $state('')
  onMount(() => {
    token = getInertiaCsrfToken() ?? getCsrfToken() ?? ''
  })
</script>

<!-- Logout is a DELETE, which only a submitted form can send in both frontends. -->
<form method="post" {action}>
  <input type="hidden" name="_method" value="delete" />
  <input type="hidden" name="authenticity_token" value={token} />
  {@render children()}
</form>

<style>
  form {
    display: flex;
    width: 100%;
  }
</style>
